import { Id2Gql } from './utils';

// These will aid in the transition to consumer services APIs, eventually will go away
export const appointmentId2Gql = id =>
  id ? Id2Gql('Appointment', id) : undefined;

export const therapistId2Gql = id => (id ? Id2Gql('Therapist', id) : undefined);

export const slotId2Gql = id =>
  id ? Id2Gql('AppointmentSlot', id) : undefined;

export const itemId2Gql = id =>
  id ? Id2Gql('SchedulableItem', id) : undefined;

export const categoryId2Gql = id => (id ? Id2Gql('Category', id) : undefined);

export const customerId2Gql = id => (id ? Id2Gql('Customer', id) : undefined);

export const membershipId2Gql = id =>
  id ? Id2Gql('Membership', id) : undefined;

export const storeId2Gql = id => (id ? Id2Gql('StoreType', id) : undefined);

export const paymentMethodId2Gql = id =>
  id ? Id2Gql('PaymentMethod', id) : undefined;

export const gql2Id = g => {
  if (!g) {
    return null;
  }
  const s = atob(g);
  const vals = s.split(':');
  return parseInt(vals[1]);
};

export const normalizeId = id => {
  if (typeof id === 'number') {
    return id;
  } else {
    return gql2Id(id);
  }
};

export const normalizePiId = pi => {
  if (typeof pi === 'number') {
    return pi;
  } else {
    return gql2Id(pi);
  }
};

export const normalizeCustomerId = id => {
  if (typeof id === 'number') {
    return id;
  } else {
    return gql2Id(id);
  }
};
